module.exports = [
  require('./compare'),
  require('./compareNatural'),
  require('./deepEqual'),
  require('./equal'),
  require('./larger'),
  require('./largerEq'),
  require('./smaller'),
  require('./smallerEq'),
  require('./unequal')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/relational/index.js
// module id = 1378
// module chunks = 0